export let ScrollAreaRootCssVars = /*#__PURE__*/function (ScrollAreaRootCssVars) {
  /**
   * The scroll area's corner height.
   * @type {number}
   */
  ScrollAreaRootCssVars["scrollAreaCornerHeight"] = "--scroll-area-corner-height";
  /**
   * The scroll area's corner width.
   * @type {number}
   */
  ScrollAreaRootCssVars["scrollAreaCornerWidth"] = "--scroll-area-corner-width";
  return ScrollAreaRootCssVars;
}({});